import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedClient } from 'contracts/Clients';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_CLIENTS_',
  }
);

export interface ListClientsState {
  data: ListedClient[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListClientsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedClient[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListClientsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListClientsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListClientsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListClientsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListClientsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listClients = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListClientsTypes = Types;
export const ListClientsActions = Creators;
